import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "d-flex align-items-center" }
const _hoisted_2 = { class: "m-0" }
const _hoisted_3 = {
  key: 0,
  class: "ml-2 badge badge-pill badge-secondary"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h5", _hoisted_2, _toDisplayString(_ctx.resource.name), 1),
      (_ctx.resource.role !== '')
        ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.resource.role), 1))
        : _createCommentVNode("", true),
      _cache[0] || (_cache[0] = _createElementVNode("div", { class: "flex-fill" }, null, -1))
    ]),
    _createElementVNode("small", null, _toDisplayString(_ctx.resource.email) + ", " + _toDisplayString(_ctx.resource.phone), 1)
  ]))
}